<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Søknad administrasjon</div>

                <v-card>
                    <v-card-title>
                        Søknader
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search.freeText" label="Søk - fritekst" clearable hide-details append-icon="mdi-magnify"></v-text-field>
                        <v-divider vertical inset class="mx-4"></v-divider>
                        <v-text-field v-model="search.companyName" label="Søk - selskap" clearable hide-details append-icon="mdi-magnify"></v-text-field>
                        <!-- <v-select v-model="search.status" :items="search.statuses" label="Status" single-line hide-details></v-select> -->

                        <application-search-by-date-year class="body-1" @updated="datesUpdated"></application-search-by-date-year>

                    </v-card-title>
                    <v-card-text>
                        <v-data-table :items="search.applications" :headers="applicationsHeaders" :loading="loading" hide-default-footer disable-pagination :mobile-breakpoint="0" class="text-no-wrap" :custom-sort="customSort">
                            <!-- <template v-slot:item.ownedBy.name="{item}">
                                {{item.ownedBy.name}}
                            </template> -->
                            <template v-slot:item.name="{item}">
                                {{item.name}}
                            </template>
                            <template v-slot:item.statuses="{item}">
                                <!-- <v-badge :icon="applicationBadgeInfo(item).icon" inline :color="applicationBadgeInfo(item).color" :value="applicationBadgeInfo(item).show">
                                    <div>{{item.name}}</div>
                                </v-badge> -->
                                <v-row>
                                    <div>{{applicationStatusText(item.statuses[item.statuses.length -1])}}</div>
                                    <v-spacer></v-spacer>
                                    <v-icon :color="applicationBadgeInfo(item).color">{{applicationBadgeInfo(item).icon}}</v-icon>
                                </v-row>
                            </template>
                            <template v-slot:item.paid="{item}">
                                {{item.payments.reduce((acc, cur) => { return acc + cur.amount},0) }}
                            </template>
                            <template v-slot:item.createdAt="{item}">
                                {{moment.unix(item.createdAt).format("YYYY-MM-DD")}}
                            </template>
                            <template v-slot:item.updatedAt="{item}">
                                {{moment.unix(item.updatedAt).format("YYYY-MM-DD")}}
                            </template>
                            <template v-slot:item.actions="{item}">
                                <v-icon class="mr-2" @click="applicationReport(item)">
                                    mdi-magnify
                                </v-icon>
                                <v-icon class="mr-2" @click="editApplication(item)">
                                    mdi-pencil-circle
                                </v-icon>
                                <v-icon class="mr-2" @click="approvalOfApplication(item)">
                                    mdi-arrow-decision
                                </v-icon>
                                <v-icon class="mr-2" @click="paymentApplication(item)">
                                    mdi-cash-100
                                </v-icon>
                                <v-icon class="mr-2" @click="deleteApplication(item)">
                                    mdi-delete-circle
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>

            </v-col>

            <v-dialog v-model="status.show" width="50%">
                <change-status v-if="status.show" :applicationId="application.id" @saved="applicationStatusChanged(application)" @canceled="status.show = false"></change-status>
            </v-dialog>

            <v-dialog v-model="showApplicationReport" width="50%">
                <v-card v-if="showApplicationReport">
                    <v-card-title class="white--text" :style="{background: colors().primary1}">
                        Søknad: {{this.application.name}}
                    </v-card-title>
                    <v-card-text>
                        <application-summary :id="application.id"></application-summary>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
import { applicationStatusText, ApplicationStatus } from "../../utilities/enums";
export default {
    data() {
        return {
            from: undefined,
            to: undefined,
            search: {
                freeText: "",
                companyName: null,
                // status: null,
                // statuses: [],
                applications: []
            },
            application: null,
            applications: [],
            applicationsHeaders: [
                {
                    text: "Organisasjon",
                    value: "ownedBy.name"
                },
                { text: "Navn", value: "name" },
                { 
                    text: "Status", 
                    value: "statuses",
                    sort: (a, b) => {

                        let aStatus = a.statuses[a.statuses.length -1];
                        let bStatus = b.statuses[b.statuses.length -1];

                        let aText = applicationStatusText(aStatus);
                        let bText = applicationStatusText(bStatus);

                        if(aText > bText){
                            return 1;
                        }
                        else if(bText > aText){
                            return -1;
                        }
                        else{
                            return 0;
                        }
                    }
                },
                { text: "Innvilget beløp", value: "grant", sortable: false },
                { text: "Utbetalt beløp", value: "paid", sortable: false },
                { text: "Opprettet på", value: "createdAt", sortable: true },
                { text: "Oppdatert på", value: "updatedAt", sortable: true },
                { text: "Handlinger", value: "actions", sortable: false }
            ],
            status: {
                show: false
            },
            showApplicationReport: false,
            moment: moment,
            loading: false
        };
    },
    methods: {
        customSort(items, sortBy, sortDesc, locale, customSorters){

            let key = sortBy[0]
            if(!key)
                return items;

            if(customSorters[key]){
                items.sort(customSorters[key])
            }
            else{
                items.sort((a,b)=>{
                    let objA;
                    if(key.includes(".")){
                        objA = key.split('.').reduce((o,i)=>o[i], a)
                    }
                    else{
                        objA = a[key];
                    }

                    let objB;
                    if(key.includes(".")){
                        objB = key.split('.').reduce((o,i)=>o[i], b)
                    }
                    else{
                        objB = b[key];
                    }
                    
                    if(objA > objB) return 1;
                    else if(objA < objB) return -1;
                    else return 0;
                });
            }

            if(sortDesc[0]){
                items.reverse()
            }

            return items;
        },
        datesUpdated(from, to) {
            this.from = moment(from).unix();
            this.to = moment(to).unix();

            this.getApplications();
        },
        async getApplications() {
            this.loading = true;
            let response = await axios.get(`/application/between?from=${this.from}&to=${this.to}`, {
                params: {
                    include: "[applicationChoices,procurements,procurementSplits,fundings,reports.[contents,createdBy],payments,statuses,createdBy,updatedBy,ownedBy]"
                }
            });
            this.applications = response.data;
            this.customFilter();
            this.loading = false;
        },
        // rowClicked(application) {
        //     this.$router.push({
        //         name: "application",
        //         params: { id: application.id }
        //     });
        // },
        applicationBadgeInfo(application) {
            if (!application.statuses || application.statuses.length == 0) {
                return { icon: undefined, show: false, color: undefined };
            }

            let appCount = application.statuses.length;
            let lastStatus = application.statuses[appCount - 1];

            switch (lastStatus.type) {
                case ApplicationStatus.GRANTED: {
                    return { show: true, icon: "mdi-check-bold", color: "success" };
                }
                case ApplicationStatus.ADMITTED: {
                    return { show: true, icon: "mdi-exclamation-thick", color: "error" };
                }
                case ApplicationStatus.INPROGRESS: {
                    return { show: true, icon: "mdi-cog", color: "warning" };
                }
                case ApplicationStatus.NEEDINFO: {
                    return { show: true, icon: "mdi-alert", color: "primary" };
                }
                default: {
                    return { show: false, icon: undefined, color: undefined };
                }
            }
        },
        async applicationStatusChanged(application) {
            let index = this.applications.findIndex(a => a.id === application.id);
            if (index > -1) {
                let app = await this.$store.dispatch("getApplication", { applicationId: application.id });
                this.applications.splice(index, 1, app);
            }

            this.status.show = false;
        },
        approvalOfApplication(application) {
            this.application = application;

            this.status.show = true;
        },
        applicationReport(application) {
            this.application = application;
            this.showApplicationReport = true;
        },
        editApplication(application) {
            this.$router.push({ path: `/application/${application.id}` });
        },
        deleteApplication(application) {
            this.$store.commit("snackbar", { show: true, text: `delete ${application.name}`, color: "success" });
        },
        paymentApplication(application) {
            this.$store.commit("snackbar", { show: true, text: `payment ${application.name}`, color: "success" });
            this.$router.push({ name: "paymentadmin", params: { id: application.id } });
        },
        applicationStatusText(status) {
            return applicationStatusText(status);
        },
        customFilter() {
            if (!("search" in this) || !("freeText" in this.search) || !this.search.freeText || !this.search.freeText.trim()) {
                this.search.applications = this.applications;
                return;
            }

            let searches = this.search.freeText.trim().split(/\s/);

            let hits = [];

            searches.forEach(search => {
                if (!search || !search.trim()) {
                    return;
                }

                search = search.toLowerCase();

                let filtered = this.applications.filter(a => {
                    let statusText =  applicationStatusText(a.statuses[a.statuses.length - 1]).toLowerCase();

                    if (a.name.toLowerCase().includes(search)) {
                        return true;
                    } else if (a.ownedBy.name.toLowerCase().includes(search)) {
                        return true;
                    } else if (statusText.includes(search))  {
                        return true;
                    }

                    return false;
                });

                hits = hits.concat(filtered);
            });

            this.search.applications = hits.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
        }
    },
    watch: {
        "search.status": {
            handler() {
                this.customFilter();
            }
        },
        "search.freeText": {
            handler() {
                this.customFilter();
            }
        }
    },
    async mounted() {
        // try {
        this.getApplications();
        // } catch (error) {
        //     throw error;
        // }
    }
};
</script>

<style lang="scss" scoped>
</style>